import { Input, Table } from 'antd';
import React from 'react'

function VitalParameterTable({ data }) {

    const columns = [
        {
            title: "Code",
            dataIndex: "vitalCode",
            key: "vitalCode",
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Normal Range",
            dataIndex: "normalRange",
            key: "normalRange",
            render: (_, record) => (
                <>
                    <div className="flex ">
                        <div>
                            <Input
                                style={{ width: "72px" }}
                                placeholder=""
                                enterButton=""
                                value={record.minimumNormalRange}
                            />
                        </div>
                        <div>
                            <Input
                                style={{ width: "72px" }}
                                placeholder=""
                                enterButton=""
                                value={record.maximumNormalRange}
                            />
                        </div>
                    </div>
                </>
            ),
        },
        {
            title: "Min Abnormal Range",
            dataIndex: "minAbnormalRange",
            key: "minAbnormalRange",
            render: (_, record) => (
                <>
                    <div className="flex ">
                        <div>
                            <Input
                                style={{ width: "72px" }}
                                placeholder=""
                                enterButton=""
                                value={record.minimumAbnormalRange}
                            />
                        </div>
                        <div>
                            <Input
                                style={{ width: "72px" }}
                                placeholder=""
                                enterButton=""
                                value={record.minimumNormalRange - 1}
                            />
                        </div>
                    </div>
                </>
            ),
        },
        {
            title: "Max Abnormal Range",
            dataIndex: "maxAbnormalRange",
            key: "maxAbnormalRange",
            render: (_, record) => (
                <>
                    <div className="flex ">
                        <div>
                            <Input
                                style={{ width: "72px" }}
                                placeholder=""
                                value={record.maximumNormalRange + 1}
                                enterButton=""
                            />
                        </div>
                        <div>
                            <Input
                                style={{ width: "72px" }}
                                placeholder=""
                                enterButton=""
                                value={record.maximumAbnormalRange}
                            />
                        </div>
                    </div>
                </>
            ),
        },
        {
            title: "Critical Range",
            dataIndex: "minimumAbnormalRange" && "minimumNormalRange",
            key: "minimumAbnormalRange" && "minimumNormalRange",
            render: (_, record) => {
                let shouldShowInputs = record.name !== 'Height' && record.name !== 'Weight';

                return shouldShowInputs ? (
                    <>
                        <div>
                            <label>{'( < ' + record.minimumAbnormalRange + ' OR  >' + record.maximumAbnormalRange + ' )'}</label>

                        </div>
                    </>
                ) : null;
            },
        },
    ];

    return (
        <>
            {/* <div>
                <div className={`min-w-full ${data ? 'w-max' : 'flex-1'} rounded-lg flex justify-center py-2`}>
                    <table className="w-full mx-2 overflow-scroll relative">
                        <thead className="sticky top-0 bg-white z-10">
                            <tr>
                                <th>Code</th>
                                <th>Name</th>
                                <th>Normal Range</th>
                                <th>Min Abnormal Range</th>
                                <th>Max Abnormal Range</th>
                                <th>Critical Range</th>
                            </tr>
                            <tr className="bg-[#DEF3F2]">
                                <td className="py-0.5" colSpan={12}></td>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            {data?.map((item, idx) => {
                                const showCritical = item.name !== "Height" && item.name !== "Weight";
                                return (
                                    <React.Fragment key={idx}>
                                        <tr>
                                            <td>{item.vitalCode}</td>
                                            <td>{item.name}</td>

                                            <td>
                                                <div className="flex gap-1 justify-center">
                                                    <Input style={{ width: "72px" }} value={item.minimumNormalRange} />
                                                    <Input style={{ width: "72px" }} value={item.maximumNormalRange} />
                                                </div>
                                            </td>

                                            <td>
                                                <div className="flex gap-1 justify-center">
                                                    <Input style={{ width: "72px" }} value={item.minimumAbnormalRange} />
                                                    <Input
                                                        style={{ width: "72px" }}
                                                        value={item.minimumNormalRange - 1}
                                                    />
                                                </div>
                                            </td>

                                            <td>
                                                <div className="flex gap-1 justify-center">
                                                    <Input
                                                        style={{ width: "72px" }}
                                                        value={item.maximumNormalRange + 1}
                                                    />
                                                    <Input
                                                        style={{ width: "72px" }}
                                                        value={item.maximumAbnormalRange}
                                                    />
                                                </div>
                                            </td>

                                            <td>
                                                {showCritical && (
                                                    <div>
                                                        <label>
                                                            {"( < " + item.minimumAbnormalRange + " OR > " + item.maximumAbnormalRange + " )"}
                                                        </label>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                        <tr className="bg-[#DEF3F2]">
                                            <td className="py-0.5" colSpan={12}></td>
                                        </tr>
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div> */}
            <Table
                dataSource={data}
                columns={columns}
                pagination={false}
            />
        </>

    )
}

export default VitalParameterTable;